import { ToastModule } from 'primeng/toast';

import { Component, ViewEncapsulation } from '@angular/core';

import { Icon } from '../icon';

@Component({
  selector: 'app-toast',
  imports: [ToastModule, Icon],
  templateUrl: './toast.html',
  styleUrl: './toast.scss',
  encapsulation: ViewEncapsulation.None,
})
export class Toast {
  protected readonly config = {
    life_time: 5000,
  };
}
